import React from "react";
import project1 from "../img/Project1.png";
import project2 from "../img/Project2.png";
import project3 from "../img/Project3.png";
import project4 from "../img/Project4.png";
import project5 from "../img/Project5.png";
import project6 from "../img/Project6.png";
import "../css/home.css";
import { Link } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
function ProjectsList() {
const projectData = [
  {
    img: project1,
    title: "PureNest Care",
    desc: "Comprehensive home cleaning designed to refresh and revitalize every corner.",
  },
  {
    img: project2,
    title: "KitchenFresh Pro",
    desc: "Deep kitchen cleaning that removes grease, stains, and harmful bacteria.",
  },
  {
    img: project3,
    title: "AquaClean Bath",
    desc: "Thorough bathroom sanitization for a hygienic and sparkling finish.",
  },
  {
    img: project4,
    title: "HomeGlow Service",
    desc: "Complete home deep cleaning for a healthier and dust-free living space.",
  },
  {
    img: project5,
    title: "SparkleKitchen",
    desc: "Professional kitchen cleaning ensuring shine, safety, and hygiene.",
  },
  {
    img: project6,
    title: "FreshBath Plus",
    desc: "Advanced bathroom cleaning that delivers freshness and long-lasting cleanliness.",
  },
];


  return (
    <section className="projects-section py-5">
      <div className="container">
        {/* Section Heading */}
        <div className="text-center mb-5">
          <h6 className="section-tag">OUR WORK</h6>
                    <hr className="center-hr " />
          <h2 className="section-title">Recent Projects</h2>
          <p className="section-desc">
            Check out some of the professional cleaning projects we’ve completed
            for our clients.
          </p>
        </div>

        {/* Projects Cards */}
        <div className="row">
          {projectData.map((project, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="project-card h-100 text-center">
                <img
                  src={project.img}
                  alt={project.title}
                  className="img-fluid project-img"
                />
                <div className="project-content p-3">
                  <h5 className="project-title">{project.title}</h5>
                  <p className="project-desc">{project.desc}</p>
                  <Link   to="/contact" className="project-btn d-inline-flex align-items-center gap-2">  <FaPhoneAlt /> &nbsp;Call Now</Link>
                </div>
              </div>
            </div>
          ))}
        </div>

    
      </div>
    </section>
  );
}

export default ProjectsList;
